import logo from "../assets/speak-schedule-blue-logo.png";
import { useEffect } from "react";

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full px-4">
      <div className="max-w-2xl mx-auto mt-10">
        <img src={logo} alt="image" className="w-16 h-16 rounded-lg" />
        <h1 className="mt-2 text-4xl font-bold">Terms and Conditions</h1>
        <p className="text-base text-neutral-400 mt-2">
          Last Updated: 2025-02-24
        </p>

        <div className="details mt-4">
          <p>
            Welcome to the SPEAK Schedule! These terms and conditions outline
            the rules and regulations for using the SPEAK Schedule. By accessing
            this app, we assume you accept these terms and conditions. Do not
            continue to use the SPEAK Schedule if you do not agree to all of the
            terms and conditions stated on this page.
          </p>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Copyright Policy</h1>
            <p className="mt-1">
              All content generated within SPEAK Schedule ("Generated Content")
              is owned by the users. The app does not claim any intellectual
              property rights over the Generated Content created by its users.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">License to Use</h1>
            <p className="mt-1">
              Subject to your compliance with these terms, SPEAK Schedule grants
              you a non-exclusive, non-transferable, revocable license to access
              and use the app solely for your personal, non-commercial purposes.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">
              Trial Period and Subscription
            </h1>
            <h3 className="text-xl font-bold mt-2">Trial Period</h3>
            <p className="mt-1">
              SPEAK Schedule offers a free trial period during which you can
              access all features without charge. The duration of the free trial
              is 7 days from the date of registration.
            </p>
            <h3 className="text-xl font-bold mt-2">Subscription</h3>
            <p className="mt-1">
              After the trial period ends, continued use of SPEAK Schedule
              requires a paid subscription. Details regarding subscription plans
              and fees are available within the app and on our website.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Payment</h1>
            <p className="mt-1">
              Payments must be made according to the selected subscription plan.
              Failure to make timely payments may result in the suspension or
              termination of your access to the app.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Functions of the App</h1>
            <ul className="list-disc ml-5 mt-1">
              <li>Schedule events and appointments.</li>
              <li>Set reminders for various tasks and events.</li>
              <li>Automatically organize your schedule based on your input.</li>
            </ul>
            <p className="mt-1">
              Each function is provided "as is" without any guarantees of
              completeness, accuracy, or timeliness, and any warranties of any
              kind.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">No Warranties</h1>
            <p className="mt-1">
              SPEAK Schedule is provided "as is," with all faults, and expressly
              disclaims all warranties of any kind, whether express or implied,
              including, but not limited to, implied warranties of
              merchantability, fitness for a particular purpose, and
              non-infringement.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Limitation of Liability</h1>
            <p className="mt-1">
              In no event shall SPEAK Schedule, nor any of its officers,
              directors, or employees, be liable for any indirect,
              consequential, or special liabilities arising out of or in any way
              related to your use of this app.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Indemnification</h1>
            <p className="mt-1">
              You agree to indemnify and hold harmless SPEAK Schedule and its
              directors, officers, employees, and agents from and against any
              and all claims, liabilities, damages, losses, or expenses,
              including reasonable attorneys' fees and costs, arising out of or
              in any way connected with your breach of these terms and
              conditions.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Severability</h1>
            <p className="mt-1">
              If any provision of these terms is found to be invalid or
              unenforceable under any applicable law, that provision shall be
              deemed omitted without affecting the remaining provisions herein.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Variation of Terms</h1>
            <p className="mt-1">
              SPEAK Schedule reserves the right to revise these terms at any
              time as it sees fit, and by using this app, you are expected to
              review these terms regularly.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Assignment</h1>
            <p className="mt-1">
              SPEAK Schedule may assign or transfer its rights and obligations
              under these terms without notification, but you may not assign or
              transfer any rights or obligations under these terms.
            </p>
          </div>

          <div className="mt-4 mb-8">
            <h1 className="text-2xl font-bold">Entire Agreement</h1>
            <p className="mt-1">
              These terms constitute the entire agreement between SPEAK Schedule
              and you, concerning your use of this app and supersede all prior
              agreements and understandings.
            </p>
          </div>

          <footer className="w-full mt-10 py-4 bg-neutral-100 text-center">
            <h1>
              All Rights Reserved{" "}
              <a href="https://thekaizenglobal.com/">Kaizen Global</a> 2025
            </h1>
          </footer>
        </div>
      </div>
    </div>
  );
}
